import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const SegmentManagerDpEl = styled(Div)`
    & {
        transition: all 0.5s;
        display: -ms-grid;
        display: grid;
        grid-template-columns: 2fr 1fr 1fr auto;
        grid-template-areas:
            'leg departure return pax'
            'ssCheckbox ssDeparture ssReturn cta';
    }

    & .SegmentManagerDP-Leg {
        -ms-grid-row: 1;
        -ms-grid-column: 1;
        grid-area: leg;
    }

    & .SegmentManagerDP-Departure {
        -ms-grid-row: 1;
        -ms-grid-column: 2;
        grid-area: departure;
        margin-left: -1px;
    }

    & .SegmentManagerDP-Return {
        -ms-grid-row: 1;
        -ms-grid-column: 3;
        grid-area: return;
    }

    & .SegmentManager-Rooms-Pax {
        -ms-grid-row: 1;
        -ms-grid-column: 4;
        grid-area: pax;
    }

    & .SegmentManagerDP-SSCheckbox {
        -ms-grid-row: 2;
        -ms-grid-column: 1;
        grid-area: ssCheckbox;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    & .SegmentManagerDP-SSDeparture {
        -ms-grid-row: 2;
        -ms-grid-column: 2;
        grid-area: ssDeparture;
    }

    & .SegmentManagerDP-SSReturn {
        -ms-grid-row: 2;
        -ms-grid-column: 3;
        grid-area: ssReturn;
    }

    & .SegmentManagerDP-CTA {
        -ms-grid-row: 2;
        -ms-grid-column: 4;
        grid-area: cta;
        justify-self: end;
    }
`;
